import React, { PropTypes, Component } from 'react';
import { map, sortBy, reverse } from 'lodash';
import { connect } from 'react-redux';
import cx from 'classnames';
import ChevronIcon from '../../../../../../common/svgs/ChevronIcon';
import Button from '../../../../../../common/components/Button';

import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn
} from 'material-ui/Table';

const columnStyle = {
    paddingLeft: '0px',
    paddingRight: '10px'
};

const LastColumnStyle = {
    paddingLeft: '0px',
    paddingRight: '0px',
    width: '95px'
};

const tableStyle = {
    borderBottom: '1px solid rgb(224, 224, 224)'
};

@connect()
export default class UsersTable extends Component {

    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        users: PropTypes.array.isRequired,
        className: PropTypes.string,
        showEditUserModal: PropTypes.func.isRequired,
    }

    constructor() {
        super();
        this.openEditUserModal = ::this.openEditUserModal;

        this.state = {
            isFlipped: false,
            sortBy: 'name',
            reserve: false,
        };
    }

    flipColumn() {
        this.setState({ isFlipped: !this.state.isFlipped, sortBy: 'activeState', reverse: !this.state.reverse });
    }

    openEditUserModal(employee) {
      this.props.showEditUserModal && this.props.showEditUserModal(employee);
    }

    renderUser(user, index) {
        return (<TableRow key={user.employeeId} displayBorder data-id={`Employee ${user.employeeId}`}>
            <TableRowColumn className='column' style={columnStyle} data-id={`Name ${index}`} >
                {user.name}
            </TableRowColumn>
            <TableRowColumn className='column' style={columnStyle} data-id={`Title ${index}`} >
                {user.title}
            </TableRowColumn>
            <TableRowColumn className='column' style={columnStyle} data-id={`Email ${index}`} >
                {user.email}
            </TableRowColumn>
            <TableRowColumn className='column' style={columnStyle} data-id={`defaultRole ${index}`} >
              {user.defaultRoleName}
            </TableRowColumn>
          <TableRowColumn className='column' style={columnStyle} data-id={`Status ${index}`} >
                {
                    user.activeState === 'enabled' &&
                    <div>
                        <span className='status-circle status-circle-active'></span> Activate User
                    </div>
                }
                {
                    user.activeState === 'pending' &&
                    <div>
                        <span className='status-circle status-circle-inactive'></span> Inactivate User
                    </div>
                }
            </TableRowColumn>
            <TableRowColumn className='column' style={LastColumnStyle} data-id={`Edit ${index}`}>
                <Button
                    data-id='edit-user'
                    className='button-secondary button-secondary-edit-user'
                    label='EDIT'
                    onClick={() => this.openEditUserModal(user)}

                />
            </TableRowColumn>
        </TableRow >);

    }
    render() {

        const sortedUsers = sortBy(this.props.users, this.state.sortBy);
        const users = this.state.reverse ? reverse(sortedUsers) : sortedUsers;

        return (<div className={`users-table ${this.props.className}`}>

            <Table style={tableStyle} selectable={false} multiSelectable={false}>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                        <TableHeaderColumn className='header-column' style={columnStyle}>Name</TableHeaderColumn>
                        <TableHeaderColumn className='header-column' style={columnStyle}>Title</TableHeaderColumn>
                        <TableHeaderColumn className='header-column' style={columnStyle}>Email</TableHeaderColumn>
                        <TableHeaderColumn className='header-column' style={columnStyle}>Default Role</TableHeaderColumn>
                        <TableHeaderColumn className='header-column' style={columnStyle}>
                            Status
                              <span
                                className={cx('chevron', { flipped: this.state.isFlipped })}
                                onClick={::this.flipColumn}>
                               <ChevronIcon />
                            </span>
                        </TableHeaderColumn>
                        <TableHeaderColumn className='header-column' style={LastColumnStyle}>Edit</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                    {map(users, ::this.renderUser)}
                </TableBody>
            </Table>

        </div>);
    }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Settings/User/Landing/UsersTable/index.js